/*
  Delivery dates for kc-delivery-highlight ("Show as dates").

  Turns the delivery-time sentence of the product metafield ("In 6-8 Wochen bei Dir Zuhause")
  into a date range counted from the day the customer is looking at it: today + 6 weeks →
  today + 8 weeks. It has to run in the browser — Shopify caches the rendered page, so a date
  computed in Liquid would be days old. If the sentence has no "N-M weeks/days" range, the
  server-rendered text is left untouched.
*/

const RANGE = /(\d+)\s*(?:-|–|—|bis|to|à|a|tot)\s*(\d+)\s*(\p{L}+)/iu;

function unitInDays(word) {
  const w = word.toLowerCase();
  if (/^(woche|week|semaine|settiman|weke)/.test(w)) return 7;
  if (/^(tag|day|jour|giorn|dag)/.test(w)) return 1;
  return 0;
}

function addDays(date, days) {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

function render(el) {
  const match = (el.dataset.source || "").match(RANGE);
  const template = el.dataset.template;
  if (!match || !template) return;

  const days = unitInDays(match[3]);
  if (!days) return;

  const min = Math.min(+match[1], +match[2]) * days;
  const max = Math.max(+match[1], +match[2]) * days;
  const today = new Date();
  const lang = document.documentElement.lang || undefined;
  const from = addDays(today, min);
  const to = addDays(today, max);

  if (el.dataset.style === "range") {
    // Compact range, block setting "Date style: Range": "3–17 November", or
    // "28 Oktober – 11 November" across two months. Month names come from Intl
    // in the page language, so /fr and /it need no translation.
    el.textContent = compactRange(from, to, lang);
  } else {
    const format = new Intl.DateTimeFormat(lang, { day: "numeric", month: "short" });
    el.textContent = template
      .replace("[from]", format.format(from))
      .replace("[to]", format.format(to));
  }
  el.dataset.kcDeliveryDatesDone = "";
}

function compactRange(from, to, lang) {
  const month = new Intl.DateTimeFormat(lang, { month: "long" });
  if (from.getMonth() === to.getMonth() && from.getFullYear() === to.getFullYear()) {
    return `${from.getDate()}–${to.getDate()} ${month.format(to)}`;
  }
  return `${from.getDate()} ${month.format(from)} – ${to.getDate()} ${month.format(to)}`;
}

function renderAll() {
  document.querySelectorAll("[data-kc-delivery-dates]:not([data-kc-delivery-dates-done])").forEach(render);
}

renderAll();

// A variant change re-renders the product section, block included.
document.addEventListener("variant:rerendered", renderAll);
document.addEventListener("product:rerender", () => setTimeout(renderAll, 0));
document.addEventListener("shopify:section:load", renderAll);
